module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "Nebraska.4cb4de52.webp";